import { type RequestPayload, router } from "@inertiajs/core";
import { CoachForm } from "../../../components/coach/CoachForm";
import { getFullName } from "../../../helpers/stringHelper";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Coach } from "../../../models/coach";
import { coach_path, coaches_path } from "../../../routes";

type CoachEditProps = {
  coach: Coach;
};

export default function CoachEdit({ coach }: CoachEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(coach_path, coach.id), values);

  return (
    <ContentShell title={`Coach ${getFullName(coach)}`} onBack={() => router.get(pathWithYearContext(coaches_path))}>
      <CoachForm coach={coach} onSubmit={onSubmit} submitButtonLabel="Speichern" />
    </ContentShell>
  );
}
